import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <path
      d="M16.7072 12.2929L15.293 10.8787L13.0001 13.1716V2H11.0001V13.1716L8.70717 10.8787L7.29295 12.2929L12.0001 17L16.7072 12.2929Z"
      fill="#21201F"
    />
    <path
      d="M8 20H16C16.9592 20 17.5785 19.9989 18.0525 19.9666C18.5085 19.9355 18.6821 19.8822 18.7654 19.8478C19.2554 19.6448 19.6448 19.2554 19.8478 18.7654C19.8822 18.6821 19.9355 18.5085 19.9666 18.0525C19.9989 17.5785 20 16.9592 20 16V11H22V16C22 17.8638 22 18.7957 21.6955 19.5307C21.2895 20.5108 20.5108 21.2895 19.5307 21.6955C18.7956 22 17.8638 22 16 22H8C6.13623 22 5.20435 22 4.46927 21.6955C3.48915 21.2895 2.71046 20.5108 2.30448 19.5307C2 18.7957 2 17.8638 2 16V11H4V16C4 16.9592 4.00108 17.5785 4.03342 18.0525C4.06453 18.5085 4.11777 18.6821 4.15224 18.7654C4.35523 19.2554 4.74458 19.6448 5.23463 19.8478C5.31786 19.8822 5.49152 19.9355 5.94752 19.9666C6.42148 19.9989 7.04075 20 8 20Z"
      fill="#21201F"
    />
  </>,
  'DownloadIcon2',
)
